function appendR9RouteScope(params) {var dept=document.documentElement.dataset.fsDepartment||new URL(location.href).searchParams.get('fs_department')||'all';params.set('fs_department',dept);var handle=params.get('collections');if(!handle)return params;params.set('r9_route','native');var page=new URL(location.href),parts=page.pathname.split('/').filter(Boolean);if(parts[0]!=='collections'||parts[1]!==handle||parts.length!==2)return params;var unsupported=false;page.searchParams.forEach(function(v,k){if(k.indexOf('uff_')===0||k==='usf_sort')unsupported=true;});if(unsupported)return params;var routes=[{"department":"traditions","handle":"lounge-chairs-casual","scopeKey":"r9route-traditions-4782d217f322cbcde4b1ac36"},{"department":"traditions","handle":"chaise-lounges-daybeds-casual","scopeKey":"r9route-traditions-adeaffc6bb077d8c40656481"},{"department":"traditions","handle":"coffee-cocktail-tables-casual","scopeKey":"r9route-traditions-8e8d4db0d3c5dcba05506183"},{"department":"traditions","handle":"ottomans-stools-casual","scopeKey":"r9route-traditions-c5eaa17523ae32bfaf2dee35"},{"department":"traditions","handle":"benches-casual","scopeKey":"r9route-traditions-f66d6e79e6db7e15e4094007"},{"department":"traditions","handle":"game-tables-casual","scopeKey":"r9route-traditions-1451d2e455c163a28d857aec"},{"department":"traditions","handle":"dining-chairs-casual","scopeKey":"r9route-traditions-8c34a8c7835c658c5fd90dd0"},{"department":"traditions","handle":"dining-tables-casual","scopeKey":"r9route-traditions-8afd5c72775aa2e2acc12fb1"},{"department":"traditions","handle":"casual-banquettes","scopeKey":"r9route-traditions-b46ad1a89606a7ead80f27f0"},{"department":"traditions","handle":"bar-counter-stools-casual","scopeKey":"r9route-traditions-75f550d4500d8e9d558778b1"},{"department":"traditions","handle":"bar-counter-tables-casual","scopeKey":"r9route-traditions-b8575c313aad106b8f0c0349"},{"department":"traditions","handle":"cabinets-curios-casual","scopeKey":"r9route-traditions-4c4506eb6f44d633aaa2a1ea"},{"department":"traditions","handle":"sideboards-credenzas-casual","scopeKey":"r9route-traditions-cd4402bbbfa322e495904728"},{"department":"traditions","handle":"islands-casual","scopeKey":"r9route-traditions-cdcb1d7857309081919ad2fb"},{"department":"traditions","handle":"bookcases-etageres-casual","scopeKey":"r9route-traditions-47126df4e6f4e21c3ffe5f28"},{"department":"traditions","handle":"console-sofa-tables-casual","scopeKey":"r9route-traditions-6999822126ce2f53e4106bca"},{"department":"traditions","handle":"wardrobes-casual","scopeKey":"r9route-traditions-a1aae2527fa214391990c030"},{"department":"traditions","handle":"dressers-chests-casual","scopeKey":"r9route-traditions-1dd38bfa542acdfb8bca5e3c"},{"department":"traditions","handle":"nightstands-bedside-tables-casual","scopeKey":"r9route-traditions-a0d7484672c94d170337554f"},{"department":"traditions","handle":"vanity-desks-casual","scopeKey":"r9route-traditions-c028d8a1fe1f5c5f86efb418"},{"department":"traditions","handle":"office-task-chairs-casual","scopeKey":"r9route-traditions-c8bc5755df1817d4e8d4e6f1"},{"department":"traditions","handle":"file-storage-casual","scopeKey":"r9route-traditions-9714b96a3a00559d8a5e754e"},{"department":"traditions","handle":"chandeliers-casual","scopeKey":"r9route-traditions-2f523c2bc81376236c8987d2"},{"department":"traditions","handle":"flush-and-semi-flush-mounts-casual","scopeKey":"r9route-traditions-2b4e6c0f5b585d9bbc109a03"},{"department":"traditions","handle":"pendant-lights-casual","scopeKey":"r9route-traditions-f7d509ce837d02961d64353d"},{"department":"traditions","handle":"multi-light-pendants-casual","scopeKey":"r9route-traditions-880c13dfc7e26f455826c7be"},{"department":"traditions","handle":"wall-lighting-sconces-casual","scopeKey":"r9route-traditions-7f43c22d32fbe679a45a0995"},{"department":"traditions","handle":"picture-lights-casual","scopeKey":"r9route-traditions-71a3acd01b36197169531039"},{"department":"traditions","handle":"table-lamps-casual","scopeKey":"r9route-traditions-42a3b1aabe003d1f449225b2"},{"department":"traditions","handle":"bathroom-lighting-casual","scopeKey":"r9route-traditions-5137c71b6d4724973406c9d4"},{"department":"traditions","handle":"shop-bath-vanities-casual","scopeKey":"r9route-traditions-4b1c65d99da112a5b4e1181c"},{"department":"traditions","handle":"wall-mirrors-casual","scopeKey":"r9route-traditions-bf495a1bf9bcd0d3ae3c5260"},{"department":"traditions","handle":"standing-mirrors-casual","scopeKey":"r9route-traditions-f0846f5d089ac7f54673f75c"},{"department":"traditions","handle":"new-casual","scopeKey":"r9route-traditions-1f5bbd7b2d7fb6d54eeb2ca0"}];var match=routes.find(function(r){return r.department===dept&&r.handle===handle;});if(match)params.set('r9_route',match.scopeKey);return params;}
/* AI Search collection listing. It deliberately owns the collection grid so a
 * merchant can remove the legacy filter app without changing the storefront
 * collection experience. All data stays on the signed, same-origin App Proxy. */
(function () {
  'use strict';

  var host = document.getElementById('ais-collection-filters');
  if (!host) return;

  function normalizeProxyBase(value) {
    var path = String(value || '')
      .trim()
      .replace(/\/+$/, '');
    return /^\/apps\/[A-Za-z0-9][A-Za-z0-9_-]*$/.test(path) ? path : '/apps/ai-search';
  }

'use strict';
// Same-origin storefront route; the upstream backend mount is /apps/ai-search.
function resolveR9DraftProxyBase(windowValue, nativeBase) {
  var theme = '188713664557';
  var shopify = windowValue && windowValue.Shopify;
  if (!shopify || String(shopify.theme && shopify.theme.id || '') !== theme) return nativeBase;
  return '/apps/ai-search-1';
}
'use strict';
// Draft-only request scope. This public marker does not authenticate a request.
function createDraftApiPreviewContext(windowValue) {
  var theme = '188713664557';
  function prepare(rawUrl, proxyBase) {
    if (!windowValue || typeof rawUrl !== 'string' || typeof proxyBase !== 'string') return rawUrl;
    var current, target;
    try { current = new URL(windowValue.location.href); target = new URL(rawUrl, current.origin); } catch (_) { return rawUrl; }
    var shopify = windowValue.Shopify;
    if (!shopify || String(shopify.theme && shopify.theme.id || '') !== theme ||
      !(current.searchParams.get('preview_theme_id') === theme || shopify.previewMode === true)) return rawUrl;
    if (target.origin !== current.origin || !(target.pathname === proxyBase || target.pathname.indexOf(proxyBase + '/') === 0)) return rawUrl;
    var values = target.searchParams.getAll('preview_theme_id');
    if (values.length && (values.length !== 1 || values[0] !== theme)) throw new Error('Conflicting draft request scope');
    if (values.length) return rawUrl;
    // Append without reserializing any existing target, intent or query value.
    var hash = rawUrl.indexOf('#'), fragment = hash < 0 ? '' : rawUrl.slice(hash), base = hash < 0 ? rawUrl : rawUrl.slice(0, hash);
    return base + (base.indexOf('?') < 0 ? '?' : /[?&]$/.test(base) ? '' : '&') + 'preview_theme_id=' + theme + fragment;
  }
  return { prepare: prepare, themeId: theme, authenticatesRequest: false };
}

  var PROXY_BASE = resolveR9DraftProxyBase(window, normalizeProxyBase(host.getAttribute('data-proxy-base')));
  var r9DraftApiPreviewContext = createDraftApiPreviewContext(window);
  var COLLECTION = host.getAttribute('data-collection-handle') || '';
  // Shopify's built-in `/collections/all` is an automatic catalog view, not a
  // literal collection membership. Products therefore never carry an `all`
  // handle in Shopify's product-to-collection data. Sending it as a hard
  // filter turns the All Products page into a tiny, accidental subset.
  var IS_ALL_PRODUCTS_COLLECTION = COLLECTION.trim().toLowerCase() === 'all';
  var STOREFRONT_LOCALE = host.getAttribute('data-locale') || '';
  var STOREFRONT_MARKET = host.getAttribute('data-market') || '';
  var CARD_LABELS = {
    viewMore: host.getAttribute('data-view-more-label') || 'View More',
    addToCart: host.getAttribute('data-add-to-cart-label') || 'Add to Cart',
    buildAround: host.getAttribute('data-card-build-around-label') || 'Build Room',
    chooseVariant: host.getAttribute('data-choose-variant-label') || 'View Variants',
  };
  var ENABLE_DESIGN = host.getAttribute('data-enable-design') !== 'false';
  var UI_POLISH =
    host.getAttribute('data-ais-ui-polish') === 'true' ||
    String(window.Shopify && window.Shopify.theme && window.Shopify.theme.id || '') === '187988115501';
  if (UI_POLISH) host.setAttribute('data-ais-ui-polish', 'true');
  var AI_SEARCH_RUNTIME_SRC = host.getAttribute('data-ai-search-runtime-src') || '';
  var sharedRuntimeRequested = false;
  var LEGACY = {
    desktopColumns: Number(host.getAttribute('data-columns-desktop')) || 4,
    mobileColumns: Number(host.getAttribute('data-columns-mobile')) || 2,
    textAlignment: host.getAttribute('data-text-alignment') || 'left',
    imageStyle: host.getAttribute('data-image-style') || 'rectangle',
    imageSize: host.getAttribute('data-image-size') || 'contain',
    showGridBorder: host.getAttribute('data-show-grid-border') === 'true',
    saleType: host.getAttribute('data-sale-type') || 'text',
    salePosition: host.getAttribute('data-sale-position') || 'top-right',
    saleColor: host.getAttribute('data-sale-color') || '#ff4e4e',
    saleTextColor: host.getAttribute('data-sale-text-color') || '#ffffff',
    soldoutColor: host.getAttribute('data-soldout-color') || '#000000',
    soldoutTextColor: host.getAttribute('data-soldout-text-color') || '#ffffff',
    soldoutPosition: host.getAttribute('data-soldout-position') || 'top-right',
  };
  if (!COLLECTION) return;

  function collectionCardLabels() {
    return {
      viewMore: CARD_LABELS.viewMore,
      addToCart: CARD_LABELS.addToCart,
      buildAround: CARD_LABELS.buildAround,
      chooseVariant: CARD_LABELS.chooseVariant,
    };
  }

  function sharedCardRuntime() {
    return window.AISearch &&
      typeof window.AISearch.renderStorefrontCard === 'function' &&
      typeof window.AISearch.bindStorefrontCards === 'function'
      ? window.AISearch
      : null;
  }

  // A collection block can load before the global app embed. It must not
  // silently fall back to a non-interactive variant picker in that case. Load
  // the shared runtime when needed, then re-render the already-fetched cards
  // as soon as the shared API announces that it is ready.
  function refreshCardsWhenRuntimeReady() {
    if (!sharedCardRuntime() || !Array.isArray(lastHits)) return;
    renderCards(loadedHits);
  }

  function ensureSharedCardRuntime() {
    if (sharedCardRuntime()) {
      refreshCardsWhenRuntimeReady();
      return;
    }
    if (sharedRuntimeRequested) return;
    sharedRuntimeRequested = true;
    window.addEventListener('aisearch:ready', refreshCardsWhenRuntimeReady);
    var existing = document.getElementById('ais-overlay-script');
    if (existing) {
      existing.addEventListener('load', refreshCardsWhenRuntimeReady, { once: true });
      return;
    }
    if (!AI_SEARCH_RUNTIME_SRC || !document.head) return;
    var runtime = document.createElement('script');
    runtime.id = 'ais-overlay-script';
    runtime.src = AI_SEARCH_RUNTIME_SRC;
    runtime.async = true;
    if (typeof runtime.setAttribute === 'function') {
      runtime.setAttribute('data-proxy-base', PROXY_BASE);
      runtime.setAttribute('data-enable-design', ENABLE_DESIGN ? 'true' : 'false');
      runtime.setAttribute('data-ais-ui-polish', UI_POLISH ? 'true' : 'false');
      runtime.setAttribute('data-locale', STOREFRONT_LOCALE);
      runtime.setAttribute('data-market', STOREFRONT_MARKET);
      runtime.setAttribute('data-view-more-label', CARD_LABELS.viewMore);
      runtime.setAttribute('data-add-to-cart-label', CARD_LABELS.addToCart);
      runtime.setAttribute('data-card-build-around-label', CARD_LABELS.buildAround);
      runtime.setAttribute('data-choose-variant-label', CARD_LABELS.chooseVariant);
    }
    if (typeof runtime.addEventListener === 'function')
      runtime.addEventListener('load', refreshCardsWhenRuntimeReady, { once: true });
    document.head.appendChild(runtime);
  }

  var DEFAULT_FILTER_FACETS = [
    'productType',
    'price',
    'vendor',
    // France & Son's source-of-truth Color filter is the exact variant
    // metafield used by SO Booster. This lets the imported merge groups hide
    // raw shades/typos instead of mixing them with AI-generated color labels.
    'metafield:variant.custom.variant_colors',
    'metafield:variant.custom.variant_width_filter',
    'metafield:variant.custom.variant_depth_filter',
    'metafield:variant.custom.variant_height_filter',
    'metafield:custom.style_simplified',
    'metafield:custom.shape',
    'metafield:custom.seat_material',
    'metafield:variant.custom.variant_materials',
    'shippingWindows',
    'metafield:custom.features',
  ];
  var DISCOVERY_CONFIG = {
    filters: { enabled: true, showProductCounts: true, showSingleValueFilters: false },
    filterGroups: [],
    filterDefinitions: [],
    mergedValues: [],
    searchResults: { productsPerPage: 24, desktopColumns: 4, mobileColumns: 2 },
  };
  var SORT_OPTIONS = [
    ['relevance', 'Relevance'],
    ['price_asc', 'Price: Low to High'],
    ['price_desc', 'Price: High to Low'],
    ['newest', 'Newest'],
  ];
  var currentFilters = {};
  var activeSort = 'relevance';
  var currentPage = 1;
  var pageSize = 24;
  var totalResults = 0;
  // A source-verified search may stop after filling a page plus one. Its
  // `total` is then only a lower bound, while server `hasMore` is the single
  // authoritative continuation signal.
  var totalIsExact = true;
  var hasMoreResults = false;
  var loadedHits = [];
  var loadingMoreResults = false;
  var continuationLoadFailed = false;
  var continuationObserver = null;
  var exactTotalScope = '';
  var exactTotalValue = null;
  var exactTotalRequestScope = '';
  var exactTotalFailedScope = '';
  var facetData = null;
  var facetsAreExact;
  var facetGroupCounts;
  var numericFacetData = null;
  var requestSequence = 0;
  var priceDebounce = null;
  var viewMode = 'compact';
  // Only opaque plan references are kept in the collection URL. This lets a
  // page/sort continuation reuse the exact collection scope while a facet
  // change creates an explicit immutable child revision.
  var currentConstraintPlan = null;
  var currentPlanHasRelaxations = false;
  var pendingConstraintPlanRefinement = null;
  var CONSTRAINT_PLAN_ID_PATTERN = /^[A-Za-z0-9_-]{22,128}$/;

  function positivePlanRevision(value) {
    var raw = String(value || '');
    if (!/^\d+$/.test(raw)) return null;
    var revision = Number(raw);
    return Number.isSafeInteger(revision) && revision >= 1 && revision <= 1000000 ? revision : null;
  }
  function planReference(value) {
    if (!value || typeof value !== 'object') return null;
    var id = String(value.id || '');
    var revision = positivePlanRevision(value.revision);
    return CONSTRAINT_PLAN_ID_PATTERN.test(id) && revision ? { id: id, revision: revision } : null;
  }
  function planReferenceFromUrl(params, prefix) {
    var id = params.get(prefix + 'id');
    var revision = positivePlanRevision(params.get(prefix + 'revision'));
    return id && CONSTRAINT_PLAN_ID_PATTERN.test(id) && revision
      ? { id: id, revision: revision }
      : null;
  }
  function beginPlanRefinement() {
    var parent = currentConstraintPlan || pendingConstraintPlanRefinement;
    currentConstraintPlan = null;
    pendingConstraintPlanRefinement = parent || null;
  }
  function appendPlanTransport(params) {
    if (currentConstraintPlan) {
      params.set('constraintPlanId', currentConstraintPlan.id);
      params.set('constraintPlanRevision', String(currentConstraintPlan.revision));
    } else if (pendingConstraintPlanRefinement) {
      params.set('constraintPlanRefinementOfId', pendingConstraintPlanRefinement.id);
      params.set(
        'constraintPlanRefinementOfRevision',
        String(pendingConstraintPlanRefinement.revision),
      );
    }
    return params;
  }
  function rememberConstraintPlan(plan) {
    var next = planReference(plan);
    if (!next) return false;
    var changed =
      !currentConstraintPlan ||
      currentConstraintPlan.id !== next.id ||
      currentConstraintPlan.revision !== next.revision ||
      pendingConstraintPlanRefinement;
    var relaxed = Boolean(Array.isArray(plan.userApprovedRelaxations) && plan.userApprovedRelaxations.length);
    changed = changed || relaxed !== currentPlanHasRelaxations;
    currentPlanHasRelaxations = relaxed;
    currentConstraintPlan = next;
    pendingConstraintPlanRefinement = null;
    return changed;
  }

  function escapeHTML(value) {
    var node = document.createElement('div');
    node.textContent = String(value == null ? '' : value);
    return node.innerHTML;
  }
  function formatPrice(value) {
    var amount = Number(value);
    return Number.isFinite(amount) && amount > 0
      ? '$' +
          amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : '';
  }
  function productUrl(hit) {
    return '/products/' + encodeURIComponent(hit.handle || '');
  }
  function productsPerPage() {
    var configured = Number((DISCOVERY_CONFIG.searchResults || {}).productsPerPage || 24);
    return Math.max(4, Math.min(60, Math.round(configured) || 24));
  }
  function hasActiveFilters() {
    return Object.keys(currentFilters).some(function (key) {
      return Array.isArray(currentFilters[key]) && currentFilters[key].length;
    });
  }
  function collectionScopeKey() {
    var filters = {};
    Object.keys(currentFilters)
      .sort()
      .forEach(function (key) {
        filters[key] = (currentFilters[key] || []).slice().sort();
      });
    return JSON.stringify({
      collection: COLLECTION,
      filters: filters,
      sort: activeSort,
      plan: currentConstraintPlan
        ? { id: currentConstraintPlan.id, revision: currentConstraintPlan.revision }
        : null,
      pendingPlan: pendingConstraintPlanRefinement
        ? {
            id: pendingConstraintPlanRefinement.id,
            revision: pendingConstraintPlanRefinement.revision,
          }
        : null,
    });
  }
  function hasExactTotalForCurrentScope() {
    return exactTotalValue !== null && exactTotalScope === collectionScopeKey();
  }
  function totalResultLabel() {
    if (totalIsExact) return totalResults.toLocaleString() + ' products';
    if (exactTotalFailedScope === collectionScopeKey()) return 'More products available';
    return 'Calculating total…';
  }
  function serverHasMore(data, legacyFallback) {
    if (data && typeof data.hasMore === 'boolean') return data.hasMore;
    // A partial response without `hasMore` is not safe to infer from its
    // lower-bound total. Exact legacy responses retain their old fallback.
    if (data && data.totalIsExact === false) return false;
    return Boolean(legacyFallback);
  }
  function hasFacetValues(facets) {
    return (
      !!facets &&
      Object.keys(facets).some(function (key) {
        return Array.isArray(facets[key]) && facets[key].length;
      })
    );
  }
  function filterSettings() {
    return DISCOVERY_CONFIG.filters || { enabled: true };
  }
  function filterDefinition(key) {
    return (DISCOVERY_CONFIG.filterDefinitions || []).find(function (item) {
      return item && item.facet === key;
    });
  }
  function numericFilterDefinition(key) {
    var definition = filterDefinition(key);
    return key === 'price' ||
      (definition &&
        (definition.display === 'range' ||
          (Array.isArray(definition.numericRanges) && definition.numericRanges.length)))
      ? definition || { facet: key, numericStep: 1, prefix: '$' }
      : null;
  }
  function allowedFacets() {
    if (filterSettings().enabled === false) return [];
    var groups = Array.isArray(DISCOVERY_CONFIG.filterGroups)
      ? DISCOVERY_CONFIG.filterGroups.filter(function (group) {
          return (
            group &&
            group.active !== false &&
            (group.context === 'collection' || group.context === 'both') &&
            Array.isArray(group.facets) &&
            group.facets.length
          );
        })
      : [];
    var chosen =
      groups.find(function (group) {
        return (
          Array.isArray(group.collectionHandles) && group.collectionHandles.includes(COLLECTION)
        );
      }) ||
      groups.find(function (group) {
        return !Array.isArray(group.collectionHandles) || !group.collectionHandles.length;
      });
    return (chosen ? chosen.facets : DEFAULT_FILTER_FACETS).filter(function (key) {
      var definition = filterDefinition(key);
      return (
        (DEFAULT_FILTER_FACETS.includes(key) ||
          /^metafield:(?:variant\.)?[a-z0-9_-]+\.[a-z0-9_-]+$/i.test(key)) &&
        (!definition || definition.active !== false)
      );
    });
  }
  function activeFilterGroup() {
    var groups = Array.isArray(DISCOVERY_CONFIG.filterGroups)
      ? DISCOVERY_CONFIG.filterGroups.filter(function (group) {
          return (
            group &&
            group.active !== false &&
            (group.context === 'collection' || group.context === 'both')
          );
        })
      : [];
    return (
      groups.find(function (group) {
        return (
          Array.isArray(group.collectionHandles) && group.collectionHandles.includes(COLLECTION)
        );
      }) ||
      groups.find(function (group) {
        return !Array.isArray(group.collectionHandles) || !group.collectionHandles.length;
      }) ||
      null
    );
  }
  function facetLabel(key) {
    var group = activeFilterGroup();
    var contextualTitle = group && group.facetTitles && group.facetTitles[key];
    if (contextualTitle) return String(contextualTitle);
    var labels = {
      productType: 'Type of product',
      price: 'Price',
      primaryColors: 'Color',
      'metafield:variant.custom.variant_colors': 'Color',
      canonicalCategory: 'Category',
      vendor: 'Brand',
      styleLabels: 'Style',
      materials: 'Materials',
      availabilityStates: 'Quickship',
      shippingWindows: 'Quickship',
      tags: 'Features',
      'metafield:variant.custom.variant_width_filter': 'Width',
      'metafield:variant.custom.variant_depth_filter': 'Depth',
      'metafield:variant.custom.variant_height_filter': 'Height',
      'metafield:custom.shape': 'Shape',
      'metafield:custom.seat_material': 'Seat material',
      'metafield:variant.custom.variant_materials': 'Materials',
      'metafield:custom.style_simplified': 'Style',
      'metafield:variant.custom.variant_styles': 'Rug style',
      'metafield:variant.custom.variant_sizes': 'Size',
      'metafield:custom.features': 'Features',
    };
    if (labels[key]) return labels[key];
    return String(key || '')
      .replace(/^metafield:(?:variant\.)?[a-z0-9_-]+\./i, '')
      .replace(/[_-]+/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }
  function facetValueLabel(key, value) {
    if (key === 'shippingWindows') {
      return (
        {
          ships_immediately: 'Ships immediately',
          ships_within_3_months: 'Ships within the next 3 months',
          restocking_soon: 'Restocking soon',
        }[String(value || '')] || String(value || '')
      );
    }
    if (key !== 'availabilityStates') return String(value || '');
    return (
      {
        in_stock: 'In stock',
        out_of_stock: 'Out of stock',
        backorder: 'Backorder',
        not_tracked: 'Available',
      }[String(value || '')] || String(value || '')
    );
  }
  function facetCountForDisplay(key, item, metadata) {
    if (metadata.facetsAreExact === false) return null;
    if (metadata.facetsAreExact !== true) return item.count;
    var label = String(item.value || '').trim().toLowerCase();
    var group = (DISCOVERY_CONFIG.mergedValues || []).find(function (rule) {
      return rule && rule.active !== false && rule.facet === key &&
        String(rule.label || '').trim().toLowerCase() === label;
    });
    var counts = metadata.facetGroupCounts && metadata.facetGroupCounts[key];
    if (group && counts && Object.prototype.hasOwnProperty.call(counts, group.label))
      return Number(counts[group.label]);
    // Distinct raw buckets may contain the same product. A merged value
    // needs the server's union count before it can be presented as exact.
    return Array.isArray(item.values) && item.values.length > 1 ? null : item.count;
  }

  function normalizedFacetValue(value) {
    return String(value || '').trim().toLowerCase();
  }
  function mergedFacetValues(key, values) {
    var source = Array.isArray(values) ? values : [];
    var selected = currentFilters[key] || [];
    var rules = (DISCOVERY_CONFIG.mergedValues || []).filter(function (rule) {
      return (
        rule &&
        rule.active !== false &&
        rule.facet === key &&
        rule.label &&
        Array.isArray(rule.values)
      );
    });
    var consumed = new Set();
    var output = [];
    rules.forEach(function (rule) {
      var aliases = new Set(
        rule.values.map(function (value) {
          return String(value).trim().toLowerCase();
        }),
      );
      var matched = source.filter(function (item) {
        return aliases.has(
          String(item.value || '')
            .trim()
            .toLowerCase(),
        );
      });
      // The response can omit selected aliases after another facet narrows
      // the result set. Keep their exact request values on the same option
      // so clearing the group removes its complete selection.
      var selectedAliases = selected.filter(function (value) {
        return aliases.has(normalizedFacetValue(value));
      });
      if (!matched.length && !selectedAliases.length) return;
      matched.forEach(function (item) {
        consumed.add(
          String(item.value || '')
            .trim()
            .toLowerCase(),
        );
      });
      selectedAliases.forEach(function (value) {
        consumed.add(normalizedFacetValue(value));
      });
      output.push({
        value: rule.label,
        values: Array.from(new Set(
          matched.map(function (item) {
            return String(item.value || '');
          }).concat(selectedAliases),
        )),
        count: matched.length
          ? matched.reduce(function (sum, item) {
              return sum + Number(item.count || 0);
            }, 0)
          : null,
      });
    });
    source.forEach(function (item) {
      var value = String(item.value || '');
      if (value && !consumed.has(value.trim().toLowerCase())) {
        var selectedAliases = selected.filter(function (selectedValue) {
          return normalizedFacetValue(selectedValue) === normalizedFacetValue(value);
        });
        output.push({
          value: value,
          values: Array.from(new Set([value].concat(selectedAliases))),
          count: Number(item.count || 0),
        });
        consumed.add(normalizedFacetValue(value));
      }
    });
    selected.forEach(function (value) {
      if (value && !consumed.has(normalizedFacetValue(value))) {
        output.push({
          value: value,
          values: selected.filter(function (selectedValue) {
            return normalizedFacetValue(selectedValue) === normalizedFacetValue(value);
          }),
          count: null,
        });
        consumed.add(normalizedFacetValue(value));
      }
    });
    return output;
  }
  function restoreStateFromUrl() {
    var params = new URLSearchParams(window.location.search || '');
    activeSort = SORT_OPTIONS.some(function (option) {
      return option[0] === params.get('ais_sort');
    })
      ? params.get('ais_sort')
      : 'relevance';
    currentPage = Math.max(1, Math.min(1000, Math.floor(Number(params.get('ais_page')) || 1)));
    viewMode = ['default', 'large', 'compact'].includes(params.get('ais_view'))
      ? params.get('ais_view')
      : 'compact';
    currentFilters = {};
    currentConstraintPlan = planReferenceFromUrl(params, 'ais_plan_');
    currentPlanHasRelaxations = params.get('ais_plan_scope') === 'relaxed';
    pendingConstraintPlanRefinement = planReferenceFromUrl(params, 'ais_plan_refine_');
    var permitted = new Set(allowedFacets());
    params.forEach(function (value, key) {
      if (!key.startsWith('ais_filter_')) return;
      var facet = key.slice(11);
      if (!permitted.has(facet) || !value || value.length > 200) return;
      (currentFilters[facet] || (currentFilters[facet] = [])).push(value);
    });
  }
  function syncUrlState(mode) {
    if (!window.history || !window.history.pushState) return;
    var url;
    try {
      url = new URL(window.location.href);
    } catch (_) {
      return;
    }
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (
        key === 'ais_sort' ||
        key === 'ais_page' ||
        key === 'ais_view' ||
        key === 'ais_plan_id' ||
        key === 'ais_plan_revision' ||
        key === 'ais_plan_scope' ||
        key === 'ais_plan_refine_id' ||
        key === 'ais_plan_refine_revision' ||
        key.startsWith('ais_filter_')
      )
        url.searchParams.delete(key);
    });
    if (activeSort !== 'relevance') url.searchParams.set('ais_sort', activeSort);
    if (viewMode !== 'compact') url.searchParams.set('ais_view', viewMode);
    if (currentConstraintPlan) {
      url.searchParams.set('ais_plan_id', currentConstraintPlan.id);
      url.searchParams.set('ais_plan_revision', String(currentConstraintPlan.revision));
    } else if (pendingConstraintPlanRefinement) {
      url.searchParams.set('ais_plan_refine_id', pendingConstraintPlanRefinement.id);
      url.searchParams.set(
        'ais_plan_refine_revision',
        String(pendingConstraintPlanRefinement.revision),
      );
    }
    Object.keys(currentFilters)
      .sort()
      .forEach(function (key) {
        (currentFilters[key] || []).forEach(function (value) {
          if (value) url.searchParams.append('ais_filter_' + key, value);
        });
      });
    if (currentPlanHasRelaxations) url.searchParams.set('ais_plan_scope', 'relaxed');
    if (currentPage > 1) url.searchParams.set('ais_page', String(currentPage));
    window.history[mode === 'replace' ? 'replaceState' : 'pushState'](
      {},
      '',
      url.pathname + url.search + url.hash,
    );
  }
  function fetchJSON(url, options) {
    url = r9DraftApiPreviewContext.prepare(url, PROXY_BASE);
    return fetch(
      url,
      Object.assign(
        { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
        options || {},
      ),
    ).then(function (response) {
      if (response.ok) return response.json();
      return response.text().then(function (body) {
        var error = new Error('HTTP ' + response.status);
        error.status = response.status;
        try { error.code = JSON.parse(body).code; } catch (_) {}
        throw error;
      });
    });
  }
  var facetRefresh = null;
  function cancelFacetRefresh() {
    if (!facetRefresh) return;
    facetRefresh.stopped = true;
    clearTimeout(facetRefresh.timer);
    if (facetRefresh.controller) facetRefresh.controller.abort();
    facetRefresh = null;
  }
  function startFacetRefresh() {
    if (facetsAreExact !== false || facetRefresh) return;
    var run = {
      scope: collectionScopeKey(), sequence: requestSequence, plan: currentConstraintPlan,
      attempts: 0, stopped: false, deadline: Date.now() + 15000, timer: null, controller: null,
    };
    facetRefresh = run;
    function isCurrent() {
      return !run.stopped && host.isConnected && run.sequence === requestSequence &&
        run.scope === collectionScopeKey();
    }
    async function refresh() {
      if (!isCurrent() || facetsAreExact !== false || Date.now() >= run.deadline) return;
      run.attempts += 1;
      run.controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout;
      try {
        var metadata = await Promise.race([
          fetchJSON(PROXY_BASE + '/filters?' + searchParamsForCollection(1, productsPerPage()).toString(), {
            signal: run.controller && run.controller.signal,
          }),
          new Promise(function (_, reject) {
            timeout = setTimeout(function () {
              if (run.controller) run.controller.abort();
              reject(new Error('Facet refresh deadline'));
            }, Math.min(4000, Math.max(1, run.deadline - Date.now())));
          }),
        ]);
        if (!isCurrent()) return;
        if (run.plan && metadata.constraintPlan &&
            (run.plan.id !== metadata.constraintPlan.id ||
             run.plan.revision !== metadata.constraintPlan.revision)) return;
        if (metadata.facetsAreExact === true) {
          facetData = metadata.facets || {};
          facetsAreExact = true;
          facetGroupCounts = metadata.facetGroupCounts;
          numericFacetData = metadata.numericFacets || {};
          refreshFacetPanel();
          return;
        }
        if (metadata.facetsAreExact !== false) return;
      } catch (_) {
        // Count-only failures do not replace products or clear selections.
      } finally {
        clearTimeout(timeout);
      }
      if (isCurrent() && run.attempts < 3 && facetsAreExact === false && Date.now() < run.deadline)
        run.timer = setTimeout(refresh, run.attempts * 500);
    }
    run.timer = setTimeout(refresh, 250);
  }
  function refreshFacetPanel() {
    var previous = host.querySelector('.ais-collection-sidebar');
    if (!previous) return;
    var focused = document.activeElement;
    var oldDetails = Array.from(previous.querySelectorAll('details'));
    var template = document.createElement('template');
    template.innerHTML = renderSidebar();
    var next = template.content.firstElementChild;
    next.querySelectorAll('details').forEach(function (details) {
      var numericKey = details.getAttribute('data-cf-numeric-filter');
      var matching = oldDetails.find(function (old) {
        return numericKey ? old.getAttribute('data-cf-numeric-filter') === numericKey :
          old.querySelector('summary').textContent === details.querySelector('summary').textContent;
      });
      if (matching) details.open = matching.open;
    });
    bindControls(next);
    // Keep live range inputs, including values typed before Apply, intact.
    next.querySelectorAll('[data-cf-numeric-filter]').forEach(function (details) {
      var matching = oldDetails.find(function (old) {
        return old.getAttribute('data-cf-numeric-filter') === details.getAttribute('data-cf-numeric-filter');
      });
      if (matching && matching.hasAttribute('data-cf-numeric-pending')) {
        ['min', 'max'].forEach(function (edge) {
          var source = matching.querySelector('.cf-price-' + edge);
          var target = details.querySelector('.cf-price-' + edge);
          var range = details.querySelector('.cf-range-' + edge);
          if (source && target) {
            target.value = source.value;
            if (range && source.value) range.value = source.value;
          }
        });
        if (focused && matching.contains(focused)) {
          focused = details.querySelector(focused.classList.contains('cf-price-min') ? '.cf-price-min' : '.cf-price-max');
        }
      } else if (matching) details.replaceWith(matching);
    });
    oldDetails.forEach(function (details) {
      if (details.hasAttribute('data-cf-numeric-pending') && !Array.from(next.querySelectorAll('[data-cf-numeric-filter]')).some(function (entry) {
        return entry.getAttribute('data-cf-numeric-filter') === details.getAttribute('data-cf-numeric-filter');
      })) next.appendChild(details);
    });
    previous.replaceWith(next);
    if (focused && focused.isConnected) focused.focus({ preventScroll: true });
  }

  function fetchFirstPage() {
    currentPage = 1;
    return fetchProducts({ history: 'push' });
  }
  function renderLoading() {
    host.innerHTML = '<div class="ais-collection-loading" role="status">Loading products…</div>';
  }
  function renderError(message) {
    host.innerHTML =
      '<div class="ais-collection-message ais-collection-message--error">' +
      escapeHTML(message) +
      '</div>';
  }
  function desktopViewColumns(name) {
    return name === 'large' ? 2 : name === 'default' ? 3 : 4;
  }
  function icon(name) {
    return Array(desktopViewColumns(name) * 2 + 1).join('<i></i>');
  }
  function renderViewControls() {
    return (
      '<div class="ais-collection-views" aria-label="Product view">' +
      [
        ['large', '2 products per row'],
        ['default', '3 products per row'],
        ['compact', '4 products per row'],
      ]
        .map(function (item) {
          return (
            '<button type="button" class="ais-collection-view' +
            (viewMode === item[0] ? ' is-active' : '') +
            '" data-cf-view="' +
            item[0] +
            '" style="--ais-view-columns:' +
            desktopViewColumns(item[0]) +
            '" aria-label="' +
            item[1] +
            '" aria-pressed="' +
            (viewMode === item[0]) +
            '">' +
            icon(item[0]) +
            '</button>'
          );
        })
        .join('') +
      '</div>'
    );
  }
  function renderToolbar() {
    var activeFilterCount = Object.keys(currentFilters).reduce(function (count, key) {
      return count + (currentFilters[key] || []).length;
    }, 0);
    return (
      '<div class="ais-collection-toolbar"><div class="ais-collection-toolbar__left">' +
      renderViewControls() +
      '<button type="button" class="ais-collection-filter-toggle" data-cf-filter-toggle>Filter' +
      (activeFilterCount ? ' <span>(' + activeFilterCount + ')</span>' : '') +
      '</button></div>' +
      '<p class="cf-result-count ais-collection-count">' +
      escapeHTML(totalResultLabel()) +
      '</p>' +
      '<label class="cf-sort-label ais-collection-sort"><span>Sort</span><select class="cf-sort" aria-label="Sort products">' +
      SORT_OPTIONS.map(function (item) {
        return (
          '<option value="' +
          item[0] +
          '"' +
          (activeSort === item[0] ? ' selected' : '') +
          '>' +
          item[1] +
          '</option>'
        );
      }).join('') +
      '</select></label></div>'
    );
  }
  function selectedFor(key, values) {
    var selected = currentFilters[key] || [];
    // Merged aliases are OR alternatives. A partially restored group is
    // active too, and can be cleared without first adding its other aliases.
    return values.some(function (value) {
      return selected.includes(value);
    });
  }
  function numericRangeValue(min, max) {
    return String(min || '') + ':' + String(max || '');
  }
  function numericBounds(key, definition) {
    var stats = numericFacetData && numericFacetData[key];
    if (!stats || !Number.isFinite(Number(stats.min)) || !Number.isFinite(Number(stats.max)))
      return null;
    var min = Number(stats.min);
    var max = Number(stats.max);
    return max > min ? { min: min, max: max } : null;
  }
  function numericControlMinimum(key, min) {
    // A zero in a physical-dimension facet is an import placeholder, never a
    // shopper-selectable size. The verifier correctly rejects zero inches, so
    // keep that invalid boundary out of every Width/Depth/Height-style range.
    return /variant_(?:width|depth|height|length|diameter)_filter$/i.test(key)
      ? Math.max(1, min)
      : min;
  }
  function numericStep(key, definition, min, max) {
    var configured = Number(definition.numericStep);
    if (Number.isFinite(configured) && configured > 1) return configured;
    return Math.max(1, Math.ceil(Math.max(1, max - min) / (key === 'price' ? 100 : 100)));
  }
  function clampNumeric(value, min, max, fallback) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    return Math.max(min, Math.min(max, parsed));
  }
  function formatNumericLabel(value, key) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return amount.toLocaleString(undefined, { maximumFractionDigits: key === 'price' ? 0 : 2 });
  }
  function renderNumericControl(key) {
    var definition = numericFilterDefinition(key);
    if (!definition) return '';
    var selected = String((currentFilters[key] || [])[0] || '').split(':');
    if (facetsAreExact === false) {
      return '<details class="ais-collection-facet cf-numeric-filter" data-cf-numeric-filter="' + escapeHTML(key) +
        '" data-cf-numeric-pending><summary>' + escapeHTML(facetLabel(key)) + '<b>+</b></summary>' +
        '<div class="ais-collection-facet__body ais-collection-price"><div class="cf-range-inputs"><label><span>From</span>' +
        '<input class="cf-price-min" type="number" min="' + numericControlMinimum(key, 0) +
        '" step="any" value="' + escapeHTML(selected[0] || '') + '" aria-label="Minimum ' + escapeHTML(facetLabel(key)) +
        '"></label><span>–</span><label><span>To</span><input class="cf-price-max" type="number" min="' +
        numericControlMinimum(key, 0) + '" step="any" value="' + escapeHTML(selected[1] || '') +
        '" aria-label="Maximum ' + escapeHTML(facetLabel(key)) + '"></label></div>' +
        '<p class="cf-range-hint">Set your range, then select Apply.</p><button type="button" class="cf-apply-numeric"' +
        ' data-cf-apply-numeric aria-label="Apply ' + escapeHTML(facetLabel(key)) + ' filter">Apply</button></div></details>';
    }
    var bounds = numericBounds(key, definition);
    if (!bounds) return '';
    var min = numericControlMinimum(key, bounds.min);
    var max = bounds.max;
    if (max <= min) return '';
    var selectedMin = clampNumeric(selected[0], min, max, min);
    var selectedMax = clampNumeric(selected[1], min, max, max);
    if (selectedMin > selectedMax) selectedMin = selectedMax;
    var step = numericStep(key, definition, min, max);
    var prefix = definition.prefix || (key === 'price' ? '$' : '');
    var unit =
      key === 'price'
        ? '$'
        : /variant_(?:width|depth|height|length|diameter)_filter$/i.test(key)
          ? 'in'
          : '';
    var fromLabel = 'From' + (unit ? ' (' + unit + ')' : '');
    var toLabel = 'To' + (unit ? ' (' + unit + ')' : '');
    return (
      '<details class="ais-collection-facet cf-numeric-filter" data-cf-numeric-filter="' +
      escapeHTML(key) +
      '"><summary>' +
      escapeHTML(facetLabel(key)) +
      '<b>+</b></summary>' +
      '<div class="ais-collection-facet__body ais-collection-price"><div class="cf-range-values" aria-live="polite"><output class="cf-range-min-label">' +
      escapeHTML(prefix + formatNumericLabel(selectedMin, key)) +
      '</output><span>to</span><output class="cf-range-max-label">' +
      escapeHTML(prefix + formatNumericLabel(selectedMax, key)) +
      '</output></div><div class="cf-dual-range" data-cf-dual-range><input class="cf-range-min" type="range" min="' +
      min +
      '" max="' +
      max +
      '" step="' +
      step +
      '" value="' +
      selectedMin +
      '" aria-label="Minimum ' +
      escapeHTML(facetLabel(key)) +
      '"><input class="cf-range-max" type="range" min="' +
      min +
      '" max="' +
      max +
      '" step="' +
      step +
      '" value="' +
      selectedMax +
      '" aria-label="Maximum ' +
      escapeHTML(facetLabel(key)) +
      '"></div><div class="cf-range-inputs"><label><span>' +
      escapeHTML(fromLabel) +
      '</span>' +
      '<input class="cf-price-min" type="number" min="' +
      min +
      '" max="' +
      max +
      '" step="' +
      step +
      '" value="' +
      escapeHTML(selected[0] || '') +
      '" placeholder="' +
      escapeHTML(formatNumericLabel(min, key)) +
      '" aria-label="Minimum ' +
      escapeHTML(facetLabel(key)) +
      '"></label>' +
      '<span>–</span><label>' +
      '<span>' +
      escapeHTML(toLabel) +
      '</span>' +
      '<input class="cf-price-max" type="number" min="' +
      min +
      '" max="' +
      max +
      '" step="' +
      step +
      '" value="' +
      escapeHTML(selected[1] || '') +
      '" placeholder="' +
      escapeHTML(formatNumericLabel(max, key)) +
      '" aria-label="Maximum ' +
      escapeHTML(facetLabel(key)) +
      '"></label></div><p class="cf-range-hint">Set your range, then select Apply.</p><button type="button" class="cf-apply-numeric" data-cf-apply-numeric aria-label="Apply ' +
      escapeHTML(facetLabel(key)) +
      ' filter">Apply</button></div></details>'
    );
  }
  function renderFacet(key) {
    if (numericFilterDefinition(key)) return renderNumericControl(key);
    var values = mergedFacetValues(key, facetData ? facetData[key] : []);
    var selected = currentFilters[key] || [];
    if (
      !values.length ||
      (values.length === 1 && !selected.length && filterSettings().showSingleValueFilters === false)
    )
      return '';
    var body = values
      .filter(function (item, index) {
        return index < 100 || selectedFor(key, item.values || [item.value]);
      })
      .map(function (item) {
        var valuesForOption = item.values || [item.value];
        var checked = selectedFor(key, valuesForOption);
        var displayedCount = facetCountForDisplay(key, item, {
          facetsAreExact: facetsAreExact, facetGroupCounts: facetGroupCounts,
        });
        var count =
          filterSettings().showProductCounts === false || displayedCount == null
            ? ''
            : '<em>' + Number(displayedCount).toLocaleString() + '</em>';
        return (
          '<label class="ais-collection-check"><input type="checkbox" class="cf-facet-value" data-facet="' +
          escapeHTML(key) +
          '" data-values="' +
          encodeURIComponent(JSON.stringify(valuesForOption)) +
          '"' +
          (checked ? ' checked' : '') +
          '><span>' +
          escapeHTML(facetValueLabel(key, item.value)) +
          '</span>' +
          count +
          '</label>'
        );
      })
      .join('');
    return (
      '<details class="ais-collection-facet"' +
      (selected.length ? ' open' : '') +
      '><summary>' +
      escapeHTML(facetLabel(key)) +
      '<b>+</b></summary><div class="ais-collection-facet__body">' +
      body +
      '</div></details>'
    );
  }
  function renderSidebar() {
    // A merchant can expose a canonical facet and a metafield alias with the
    // same shopper-facing label. Show one clear refinement, not duplicates.
    var labels = new Set();
    var facets = allowedFacets().filter(function (facet) {
      var label = facetLabel(facet).toLowerCase();
      if (labels.has(label)) return false;
      labels.add(label);
      return true;
    });
    return (
      '<aside class="ais-collection-sidebar" aria-label="Filter products"><div class="ais-collection-sidebar__head"><span>Filter</span><div>' +
      (hasActiveFilters()
        ? '<button type="button" class="cf-clear-filters">Clear all</button>'
        : '') +
      '<button type="button" class="ais-collection-filter-close" data-cf-filter-close aria-label="Close filters">Close</button></div>' +
      '</div>' +
      facets.map(renderFacet).join('') +
      '</aside>'
    );
  }
  // Product images are presentation fallbacks; the selected/cart variant stays unchanged.
  function cardProductImageUrls(product) {
    product = product || {};
    var productId = product.shopifyProductId || product.id;
    var candidates = [product.primaryImageUrl, product.featured_image, product.featuredImage, product.imageUrl, product.image];
    if (Array.isArray(product.images)) candidates = candidates.concat(product.images);
    var urls = [];
    candidates.forEach(function (image) {
      if (image && typeof image === 'object') {
        if (productId && image.product_id != null && String(image.product_id) !== String(productId)) return;
        image = image.src || image.url;
      }
      if (typeof image !== 'string') return;
      var url = image.trim();
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (!/^https?:\/\//i.test(url) || urls.indexOf(url) !== -1) return;
      urls.push(url);
    });
    return urls;
  }

  var cardImageFallbackStates = new WeakMap();

  function updateCardVariantImage(card, imageUrl, title) {
    var media = card.querySelector('.ais-storefront-card__media');
    if (!media) return;
    var state = cardImageFallbackStates.get(card);
    if (!state) {
      state = { failed: new Set(), image: null, current: '' };
      cardImageFallbackStates.set(card, state);
    }
    var productUrls = [];
    try { productUrls = JSON.parse(card.getAttribute('data-ais-card-product-images') || '[]'); } catch (_) {}
    var urls = cardProductImageUrls({ images: [imageUrl].concat(Array.isArray(productUrls) ? productUrls : []) });
    urls = urls.filter(function (url) { return !state.failed.has(url); });
    var nextUrl = urls[0] || '';
    var image = media.querySelector('img');
    if (nextUrl && image && state.image === image && state.current === nextUrl) return;
    // A fresh image node prevents an old variant's late error from changing the new selection.
    if (state.image) image = null;
    if (!nextUrl) {
      state.image = null;
      state.current = '';
      media.innerHTML = '<span class="ais-storefront-card__image-empty">Image unavailable</span>';
      return;
    }
    if (!image) {
      media.textContent = '';
      image = document.createElement('img');
      media.appendChild(image);
    }
    state.image = image;
    state.current = nextUrl;
    image.loading = 'lazy';
    image.srcset = ''; // Clear any inherited variant responsive candidates.
    image.alt = [card.getAttribute('data-ais-card-title'), title].filter(Boolean).join(' — ');
    image.onerror = function () {
      if (state.image !== image) return;
      state.failed.add(state.current);
      var fallback = urls.find(function (url) { return !state.failed.has(url); });
      if (!fallback) {
        state.image = null;
        state.current = '';
        media.innerHTML = '<span class="ais-storefront-card__image-empty">Image unavailable</span>';
        return;
      }
      state.current = fallback;
      image.srcset = '';
      image.src = fallback;
    };
    image.src = nextUrl;
    // An image may have failed before the card binder installed its handler.
    if (image.complete && image.naturalWidth === 0) image.onerror();
  }

  function bindCardImageFallback(card) {
    var media = card.querySelector('.ais-storefront-card__media');
    var image = media && media.querySelector('img');
    updateCardVariantImage(card, image && image.getAttribute('src') || '', '');
  }

  function renderFallbackCard(hit) {
    var id = String(hit.id || hit.shopifyProductId || '');
    var productImages = cardProductImageUrls(hit);
    var image = productImages[0]
      ? '<img src="' +
        escapeHTML(productImages[0]) +
        '" alt="' +
        escapeHTML(hit.title || '') +
        '" loading="lazy">'
      : '<span class="ais-storefront-card__image-empty">Image unavailable</span>';
    var price = formatPrice(hit.priceMin);
    if (hit.priceMax != null && Number(hit.priceMax) !== Number(hit.priceMin))
      price += ' - ' + formatPrice(hit.priceMax);
    var labels = collectionCardLabels();
    return (
      '<article class="ais-storefront-card cf-product-card ais-collection-card" data-ais-card data-product-id="' +
      escapeHTML(id) +
      '" data-ais-card-title="' + escapeHTML(hit.title || '') +
      '" data-ais-card-product-images="' + escapeHTML(JSON.stringify(productImages)) +
      '">' +
      '<a class="ais-storefront-card__media" href="' +
      productUrl(hit) +
      '" data-ais-card-product-link data-product-id="' +
      escapeHTML(id) +
      '">' +
      image +
      '</a><div class="ais-storefront-card__details ais-collection-card__details"><a class="ais-storefront-card__title-link ais-collection-title" href="' +
      productUrl(hit) +
      '" data-ais-card-product-link data-product-id="' +
      escapeHTML(id) +
      '"><h2 class="ais-storefront-card__title">' +
      escapeHTML(hit.title || '') +
      '</h2></a><p class="ais-storefront-card__price">' +
      escapeHTML(price) +
      '</p></div><div class="ais-storefront-card__variant-slot" data-ais-card-variant-slot></div><div class="ais-storefront-card__actions"><a class="ais-storefront-card__view-more" href="' +
      productUrl(hit) +
      '" data-ais-card-view-more data-product-id="' +
      escapeHTML(id) +
      '">' +
      escapeHTML(labels.viewMore) +
      '</a><button class="ais-storefront-card__cart" type="button" disabled aria-disabled="true">' +
      escapeHTML(labels.addToCart) +
      '</button><button class="ais-storefront-card__room" type="button" disabled aria-disabled="true">' +
      escapeHTML(labels.buildAround) +
      '</button></div></article>'
    );
  }
  function renderCard(hit) {
    if (sharedCardRuntime()) {
      return window.AISearch.renderStorefrontCard(hit, {
        context: 'collection',
        labels: collectionCardLabels(),
        roomEnabled: ENABLE_DESIGN,
        // The collection config is resolved independently from the global
        // app-embed /config request. Pass the immutable variant settings into
        // the shared renderer so collection and search cards cannot disagree
        // during that readiness window.
        searchResults: DISCOVERY_CONFIG.searchResults || {},
      });
    }
    return renderFallbackCard(hit);
  }

  function renderContinuation() {
    if (!loadedHits.length) return '';
    if (!hasMoreResults) {
      return '<p class="cf-collection-complete" aria-live="polite">All products loaded.</p>';
    }
    return (
      '<div class="cf-collection-continuation" data-cf-continuation aria-live="polite">' +
      '<span>' +
      (loadingMoreResults
        ? 'Loading more products…'
        : continuationLoadFailed
          ? 'Could not load more products.'
          : 'More products below') +
      '</span><button type="button" data-cf-load-more' +
      (loadingMoreResults ? ' disabled' : '') +
      '>' +
      (loadingMoreResults ? 'Loading…' : continuationLoadFailed ? 'Try again' : 'Load more') +
      '</button></div>'
    );
  }
  function renderCards(hits) {
    hits = Array.isArray(hits) ? hits : [];
    var classes =
      'ais-collection-shell is-view-' +
      viewMode +
      (LEGACY.showGridBorder ? ' has-grid-border' : '') +
      ' is-align-' +
      LEGACY.textAlignment +
      ' is-image-' +
      LEGACY.imageSize +
      ' is-image-style-' +
      LEGACY.imageStyle;
    var message = hits.length
      ? ''
      : '<div class="ais-collection-message"><p>No products match these filters.</p>' +
        (hasActiveFilters()
          ? '<button type="button" class="cf-clear-filters">Clear all filters</button>'
          : '') +
        '</div>';
    host.innerHTML =
      '<div class="' +
      classes +
      '">' +
      renderToolbar() +
      '<div class="ais-collection-layout">' +
      '<button type="button" class="ais-collection-filter-backdrop" data-cf-filter-close aria-label="Close filters"></button>' +
      renderSidebar() +
      '<main class="ais-collection-results">' +
      message +
      (hits.length
        ? '<div class="cf-product-grid ais-collection-grid">' +
          hits.map(renderCard).join('') +
          '</div>'
        : '') +
      renderContinuation() +
      '</main></div></div>';
    applyDisplaySettings();
    bindControls();
  }
  function applyDisplaySettings() {
    if (!host.style || !host.style.setProperty) return;
    host.style.setProperty(
      '--ais-collection-columns',
      desktopViewColumns(viewMode),
    );
    host.style.setProperty(
      '--ais-collection-mobile-columns',
      Math.max(1, Math.min(2, LEGACY.mobileColumns)),
    );
    host.style.setProperty('--ais-sale-color', LEGACY.saleColor);
    host.style.setProperty('--ais-sale-text-color', LEGACY.saleTextColor);
  }
  function disconnectContinuationObserver() {
    if (continuationObserver) continuationObserver.disconnect();
    continuationObserver = null;
  }
  function loadNextCollectionPage() {
    if (!hasMoreResults || loadingMoreResults) return;
    loadingMoreResults = true;
    currentPage += 1;
    fetchProducts({ append: true });
  }
  function bindCollectionContinuation() {
    disconnectContinuationObserver();
    var loadMore = host.querySelector('[data-cf-load-more]');
    if (loadMore)
      loadMore.addEventListener('click', function () {
        loadNextCollectionPage();
      });
    var marker = host.querySelector('[data-cf-continuation]');
    if (!marker || !hasMoreResults || loadingMoreResults || !('IntersectionObserver' in window)) {
      return;
    }
    continuationObserver = new window.IntersectionObserver(
      function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          disconnectContinuationObserver();
          loadNextCollectionPage();
        }
      },
      { rootMargin: '500px 0px' },
    );
    continuationObserver.observe(marker);
  }
  function bindControls(bindRoot) {
    bindRoot = bindRoot || host;
    var sort = bindRoot.querySelector('.cf-sort');
    if (sort)
      sort.addEventListener('change', function () {
        activeSort = sort.value;
        fetchFirstPage();
      });
    bindRoot.querySelectorAll('.cf-clear-filters').forEach(function (button) {
      button.addEventListener('click', function () {
        beginPlanRefinement();
        currentFilters = {};
        currentPage = 1;
        fetchProducts({ history: 'push' });
      });
    });
    bindRoot.querySelectorAll('[data-cf-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        viewMode = button.getAttribute('data-cf-view') || 'compact';
        syncUrlState('push');
        renderCards(loadedHits);
      });
    });
    if (sharedCardRuntime()) {
      window.AISearch.bindStorefrontCards(bindRoot, {
        context: 'collection',
        onRoom: function (button, anchorVariantIds) {
          var productId = button.getAttribute('data-ais-card-room');
          if (productId && typeof window.AISearch.open === 'function')
            window.AISearch.open('room', '', [productId], button, anchorVariantIds);
        },
      });
    }
    if (!sharedCardRuntime()) bindRoot.querySelectorAll('[data-ais-card]').forEach(bindCardImageFallback);
    var toggle = bindRoot.querySelector('[data-cf-filter-toggle]');
    if (toggle)
      toggle.addEventListener('click', function () {
        host.classList.toggle('is-filters-open');
      });
    bindRoot.querySelectorAll('[data-cf-filter-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        host.classList.remove('is-filters-open');
      });
    });
    bindRoot.querySelectorAll('.cf-facet-value').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        beginPlanRefinement();
        var key = checkbox.getAttribute('data-facet');
        var values = [];
        try {
          values = JSON.parse(decodeURIComponent(checkbox.getAttribute('data-values') || '[]'));
        } catch (_) {}
        var current = currentFilters[key] || [];
        currentFilters[key] = checkbox.checked
          ? Array.from(new Set(current.concat(values)))
          : current.filter(function (value) {
              return !values.includes(value);
            });
        if (!currentFilters[key].length) delete currentFilters[key];
        fetchFirstPage();
      });
    });
    bindRoot.querySelectorAll('[data-cf-numeric-filter]').forEach(function (container) {
      var key = container.getAttribute('data-cf-numeric-filter');
      var min = container.querySelector('.cf-price-min');
      var max = container.querySelector('.cf-price-max');
      var rangeMin = container.querySelector('.cf-range-min');
      var rangeMax = container.querySelector('.cf-range-max');
      var minLabel = container.querySelector('.cf-range-min-label');
      var maxLabel = container.querySelector('.cf-range-max-label');
      var apply = container.querySelector('[data-cf-apply-numeric]');
      var prefix = key === 'price' ? '$' : '';
      function sync(fromRange) {
        if (!min || !max) return;
        if (fromRange && rangeMin && rangeMax) {
          min.value = rangeMin.value;
          max.value = rangeMax.value;
        }
        var lo = Number(min.value);
        var hi = Number(max.value);
        if (min.value !== '' && max.value !== '' && Number.isFinite(lo) && Number.isFinite(hi) && lo > hi) {
          if (fromRange === 'min') hi = lo;
          else lo = hi;
          min.value = String(lo);
          max.value = String(hi);
        }
        if (rangeMin && min.value) rangeMin.value = min.value;
        if (rangeMax && max.value) rangeMax.value = max.value;
        if (minLabel && min.value)
          minLabel.textContent = prefix + formatNumericLabel(min.value, key);
        if (maxLabel && max.value)
          maxLabel.textContent = prefix + formatNumericLabel(max.value, key);
      }
      function commit() {
        if (!min || !max) return;
        beginPlanRefinement();
        clearTimeout(priceDebounce);
        var value = numericRangeValue(min.value, max.value);
        if (value === ':') delete currentFilters[key];
        else currentFilters[key] = [value];
        fetchFirstPage();
      }
      [rangeMin, rangeMax].forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', function () {
          sync(input === rangeMin ? 'min' : 'max');
        });
      });
      [min, max].forEach(function (input) {
        if (!input) return;
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            sync();
            commit();
          }
        });
      });
      if (apply)
        apply.addEventListener('click', function () {
          sync();
          commit();
        });
    });
    if (bindRoot === host) bindCollectionContinuation();
  }
  var lastHits = [];
  function searchParamsForCollection(page, size) {
    var params = new URLSearchParams();
    if (!IS_ALL_PRODUCTS_COLLECTION) params.set('collections', COLLECTION);
    params.set('page', String(page));
    params.set('pageSize', String(size));
    if (STOREFRONT_LOCALE) params.set('locale', STOREFRONT_LOCALE);
    if (STOREFRONT_MARKET) params.set('market', STOREFRONT_MARKET);
    if (activeSort !== 'relevance') params.set('sort', activeSort);
    Object.keys(currentFilters).forEach(function (key) {
      (currentFilters[key] || []).forEach(function (value) {
        if (value) params.append(key, value);
      });
    });
    return appendR9RouteScope(appendPlanTransport(params));
  }
  function appendUniqueHits(existing, next) {
    var seen = new Set(existing.map(function (hit) { return String(hit && hit.id || ''); }));
    return existing.concat(
      next.filter(function (hit) {
        var id = String(hit && hit.id || '');
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      }),
    );
  }
  function refreshRenderedCollection() {
    if (host.querySelector('.ais-collection-shell')) renderCards(loadedHits);
  }
  function requestExactCollectionTotal() {
    // A fully source-verified total protects customers from stale index
    // documents. It is a separate low-priority request so collection cards
    // never wait for a complete catalog scan before they first render.
    if (IS_ALL_PRODUCTS_COLLECTION || totalIsExact) return;
    var scope = collectionScopeKey();
    if (exactTotalScope === scope || exactTotalRequestScope === scope) return;
    exactTotalRequestScope = scope;
    exactTotalFailedScope = '';
    var params = searchParamsForCollection(1, 1);
    params.set('exactTotal', '1');
    fetchJSON(PROXY_BASE + '/search?' + params.toString())
      .then(function (data) {
        if (scope !== collectionScopeKey()) return;
        if (!data || data.totalIsExact === false) {
          exactTotalFailedScope = scope;
          return;
        }
        exactTotalValue = Math.max(loadedHits.length, Number(data.total) || 0);
        exactTotalScope = scope;
        totalResults = exactTotalValue;
        totalIsExact = true;
      })
      .catch(function () {
        if (scope === collectionScopeKey()) exactTotalFailedScope = scope;
      })
      .finally(function () {
        if (exactTotalRequestScope === scope) exactTotalRequestScope = '';
        if (scope === collectionScopeKey()) refreshRenderedCollection();
      });
  }
  async function fetchProducts(options) {
    options = options || {};
    var append = options.append === true;
    if (options.history) syncUrlState(options.history);
    cancelFacetRefresh();
    var requestId = ++requestSequence;
    if (append) {
      continuationLoadFailed = false;
      refreshRenderedCollection();
    } else {
      loadingMoreResults = false;
      continuationLoadFailed = false;
      loadedHits = [];
      disconnectContinuationObserver();
      renderLoading();
    }
    try {
      var params = searchParamsForCollection(currentPage, productsPerPage());
      var data;
      try {
        data = await fetchJSON(PROXY_BASE + '/search?' + params.toString());
      } catch (error) {
        if (requestId !== requestSequence) return;
        var state = new URLSearchParams(window.location.search);
        var canRenew = Number(error && error.status) === 409 && error.code === 'CONSTRAINT_PLAN_CONFLICT' &&
          currentConstraintPlan && !pendingConstraintPlanRefinement && !currentPlanHasRelaxations &&
          !state.getAll('ais_relax').length && state.get('broaden') !== '1';
        if (!canRenew) throw error;
        currentConstraintPlan = null;
        currentPage = 1;
        append = false;
        params.delete('constraintPlanId');
        params.delete('constraintPlanRevision');
        params.set('page', '1');
        syncUrlState('replace');
        // Exactly one strict retry, preserving collection, filters and audience.
        data = await fetchJSON(PROXY_BASE + '/search?' + params.toString());
      }
      if (requestId !== requestSequence) return;
      if (rememberConstraintPlan(data && data.constraintPlan)) syncUrlState('replace');
      lastHits = Array.isArray(data.hits) ? data.hits : [];
      pageSize = Math.max(1, Math.min(60, Math.floor(Number(data.pageSize) || productsPerPage())));
      currentPage = Math.max(1, Math.floor(Number(data.page) || currentPage));
      loadedHits = append ? appendUniqueHits(loadedHits, lastHits) : lastHits.slice();
      if (hasExactTotalForCurrentScope()) {
        totalResults = Math.max(loadedHits.length, Number(exactTotalValue) || 0);
        totalIsExact = true;
      } else {
        totalResults = Math.max(loadedHits.length, Number(data.total) || lastHits.length);
        totalIsExact = data.totalIsExact !== false;
      }
      hasMoreResults = serverHasMore(data, currentPage * pageSize < totalResults);
      loadingMoreResults = false;
      // A new filter scope replaces even an empty distribution. Only a
      // continuation may retain its earlier facets, with their precision.
      if (!append || (data.facets &&
        (data.facetsAreExact === true || hasFacetValues(data.facets)) && (
        data.facetsAreExact === true || !facetData || facetsAreExact === false ||
        (facetsAreExact !== true && hasFacetValues(data.facets))
      ))) {
        facetData = data.facets || null;
        facetsAreExact = data.facetsAreExact;
        facetGroupCounts = data.facetGroupCounts;
        numericFacetData = data.numericFacets || null;
      }
      renderCards(loadedHits);
      // The full interactive card runtime is intentionally deferred until
      // collection cards are already visible. It is a large shared asset and
      // competing for the main thread during the initial request made the
      // collection grid appear later than the underlying product response.
      ensureSharedCardRuntime();
      requestExactCollectionTotal();
      startFacetRefresh();
    } catch (_) {
      if (requestId !== requestSequence) return;
      loadingMoreResults = false;
      if (append) {
        currentPage = Math.max(1, currentPage - 1);
        continuationLoadFailed = true;
        renderCards(loadedHits);
      } else {
        renderError('Could not load products. Please try again.');
      }
    }
  }
  // Do not put the first product request behind configuration. The theme
  // block itself is enabled server-side, and the defaults are the standard
  // collection layout. Configuration still resolves in parallel and refreshes
  // the chrome before a shopper can interact with it, but product cards are
  // no longer held behind an unrelated round trip.
  var collectionConfigRequest = fetchJSON(PROXY_BASE + '/config')
    .then(function (config) {
      DISCOVERY_CONFIG = config || DISCOVERY_CONFIG;
      return DISCOVERY_CONFIG.enabled !== false;
    })
    .catch(function () {
      return true;
    });
  restoreStateFromUrl();
  window.addEventListener('popstate', function () {
    restoreStateFromUrl();
    fetchProducts();
  });
  fetchProducts();
  collectionConfigRequest.then(function (enabled) {
    if (!enabled) {
      host.innerHTML = '';
      return;
    }
    // If configuration arrives after data, repaint the toolbar and facets
    // with the merchant's final labels/settings without another search.
    if (host.querySelector('.ais-collection-shell')) renderCards(loadedHits);
  });
})();
